/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FusionMelcoModelsPreview,
    FusionMelcoModelsPreviewFromJSON,
    FusionMelcoModelsPreviewFromJSONTyped,
    FusionMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface FusionMelcoModelsDesignCollectionDefaultDesign
 */
export interface FusionMelcoModelsDesignCollectionDefaultDesign {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesignCollectionDefaultDesign
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesignCollectionDefaultDesign
     */
    name?: string | null;
    /**
     * 
     * @type {Array<FusionMelcoModelsPreview>}
     * @memberof FusionMelcoModelsDesignCollectionDefaultDesign
     */
    previews?: Array<FusionMelcoModelsPreview> | null;
}

export function FusionMelcoModelsDesignCollectionDefaultDesignFromJSON(json: any): FusionMelcoModelsDesignCollectionDefaultDesign {
    return FusionMelcoModelsDesignCollectionDefaultDesignFromJSONTyped(json, false);
}

export function FusionMelcoModelsDesignCollectionDefaultDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsDesignCollectionDefaultDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(FusionMelcoModelsPreviewFromJSON)),
    };
}

export function FusionMelcoModelsDesignCollectionDefaultDesignToJSON(value?: FusionMelcoModelsDesignCollectionDefaultDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(FusionMelcoModelsPreviewToJSON)),
    };
}


